// extracted by mini-css-extract-plugin
export default {"icon":"P0BOzfyH_yzfCN21Lab9","iconButton":"vmVfDQ9pgNwzuDKOcKSo"};